export const SITE = {
  name: "Cutting Edge Detail",
  shortName: "Cutting Edge",
  tagline: "The Pinnacle of Automotive Protection",
  phone: "021 286 2179",
  phoneRaw: "+64212862179",
  email: "cuttingedgedetailnz@gmail.com",
  address: "4B Cape Hill Rd, Pukekohe, Auckland 2120, NZ",
  socials: {
    facebook: "https://www.facebook.com/warren.edge.351/",
    instagram: "https://www.instagram.com/tisbutatriffle/",
  },
};

export const SERVICES = [
  {
    id: "paint-correction",
    name: "Paint Correction",
    blurb:
      "Multi-stage machine polishing that erases swirls, scratches and oxidation — restoring a mirror finish only craftsmanship can deliver.",
    image:
      "https://images.unsplash.com/photo-1571408194382-e5989d133359?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBibGFjayUyMGNhciUyMG1ldGFsbGljJTIwcmVmbGVjdGlvbnN8ZW58MHx8fHwxNzc3MjY0ODQ5fDA&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-2 lg:row-span-2",
    iconKey: "Sparkles",
  },
  {
    id: "ceramic-coatings",
    name: "Ceramic Coatings",
    blurb:
      "Premium hydrophobic coatings engineered for years of protection, depth of gloss and effortless wash-up.",
    image:
      "https://images.pexels.com/photos/29755710/pexels-photo-29755710.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    span: "lg:col-span-2",
    iconKey: "ShieldCheck",
  },
  {
    id: "comprehensive-detailing",
    name: "Comprehensive Detailing",
    blurb:
      "Interior + exterior rejuvenation. Decontamination, leather conditioning, fabric extraction — every surface attended to.",
    image:
      "https://images.pexels.com/photos/6873174/pexels-photo-6873174.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    span: "",
    iconKey: "Droplets",
  },
  {
    id: "vinyl-wrapping",
    name: "Vinyl Wrapping",
    blurb:
      "Bespoke wrap installs — colour change, accents, paint protection film. Precision applied, immaculately finished.",
    image:
      "https://images.unsplash.com/photo-1520340356584-f9917d1eea6f?auto=format&fit=crop&q=80&w=1200",
    span: "",
    iconKey: "Layers",
  },
];

export const BENEFITS = [
  {
    title: "Family Owned, Detail Obsessed",
    desc: "A small, devoted team led by owner Warren Edgecombe — passion fuels every step.",
    iconKey: "Heart",
  },
  {
    title: "Highest Quality Products Only",
    desc: "We invest in the finest coatings, polishes and tools — because shortcuts cost you finish.",
    iconKey: "Gem",
  },
  {
    title: "Mobile Service Available",
    desc: "Pukekohe based, but we come to you. Driveway, office or showroom — we work where you are.",
    iconKey: "MapPin",
  },
  {
    title: "Trust, Built Vehicle by Vehicle",
    desc: "Treated like our own. Every prized motor leaves better than it arrived — that is the promise.",
    iconKey: "Award",
  },
];

export const TESTIMONIALS = [
  {
    name: "Carla",
    text:
      "Our car went for a full detail and came back like new! Warren told me it's his passion and there is NO doubt in that. He even took her in on Good Friday — a public holiday! Highly recommend Warren and Cutting Edge Detail. Such great service and top notch work.",
  },
  {
    name: "Tom",
    text:
      "Warren is a business operator that takes his work of detailing cars to the next level. My car had impossible-to-shift build-up of an industrial compound. Warren took his time to figure how to remove it successfully — the car looked a million dollars.",
  },
  {
    name: "Tate",
    text:
      "Amazing! Amazing results from people who clearly know what they are doing. The service and communication was fantastic — made dealing with them a breeze. Will be going to Cutting Edge for any future jobs.",
  },
];

// Google reviews badge. Swap `url` for the exact "Write a review / See reviews"
// link from Google Business Profile when available. `count` is optional.
export const GOOGLE_REVIEWS = {
  rating: "4.9",
  count: 44,
  url: "https://g.page/r/CcStZoCiG0lQEBM/review",
};

// Booking availability used by the quote builder (preferred time, confirmed manually).
export const BOOKING = {
  workingDays: [1, 2, 3, 4, 5, 6], // Mon–Sat (0 = Sunday)
  daysAhead: 60,
  slots: [
    { id: "morning", label: "Morning", hours: "8am – 12pm" },
    { id: "afternoon", label: "Afternoon", hours: "12pm – 5pm" },
  ],
};

export const STATS = [
  { value: "10+", label: "Years on the polisher" },
  { value: "100%", label: "Family owned" },
  { value: "365", label: "Days a year passionate" },
  { value: "AKL", label: "Pukekohe + mobile" },
];
